import { rgba } from 'polished';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled, { DefaultTheme, keyframes } from 'styled-components';

import { tokens } from '../theme/tokens';

const rotate = keyframes`
	from { transform: rotateZ(0deg); }
	to { transform: rotateZ(360deg); }
`;

function spinnerFill(color: string | undefined, theme: DefaultTheme) {
	if (color && color in theme.colors) {
		return theme.colors[color as keyof typeof theme.colors];
	}

	return color ?? tokens.border.subtle;
}

const Container = styled(Box)<{ color?: string }>`
	background: conic-gradient(
		${(props) => rgba(spinnerFill(props.color, props.theme), props.color ? 0.1 : 0.25)} 25%,
		${(props) => spinnerFill(props.color, props.theme)},
		${(props) => rgba(spinnerFill(props.color, props.theme), props.color ? 0.1 : 0.25)} 75%
	);
	mask-image: radial-gradient(closest-side, transparent 75%, black 75%, black 100%);
	width: ${(props) => (typeof props.width === 'number' ? props.width : 16)}px;
	height: ${(props) => (typeof props.height === 'number' ? props.height : 16)}px;
	box-sizing: border-box;
	border-radius: 50%;

	animation: ${rotate} 2s linear infinite;
`;

export function Spinner(props: BoxProps & { color?: string; centered?: boolean }) {
	return (
		<Flex
			py={props.centered ? 3 : undefined}
			justifyContent={props.centered ? 'center' : undefined}
		>
			<Container
				ref={(ref?: HTMLDivElement) =>
					ref?.getAnimations().forEach((animation) => (animation.startTime = 0))
				}
				{...props}
			/>
		</Flex>
	);
}
